import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  computed: {
    ...mapGetters('learning', ['courseContentsWithProgress'])
  }
})
export default class GtrCourseProgress extends Vue {
  courseContentsWithProgress!: any

  get progressStatistics () {
    if (Array.isArray(this.courseContentsWithProgress)) {
      let totalContents = 0
      let completedContents = 0

      this.courseContentsWithProgress.forEach((chapter: any) => {
        chapter.contents.forEach((content: any) => {
          totalContents++
          if (content.participant_progress?.completed) {
            completedContents++
          }
        })
      })

      return {
        totalContents,
        completedContents,
        contentCompletionRate: totalContents > 0 ? ((completedContents / totalContents) * 100).toFixed(0) : 0
      }
    }

    return {}
  }

  get courseCompleted () {
    return this.progressStatistics.contentCompletionRate === '100' || false
  }
}
